import { computed } from "@vue/composition-api";
import { Path } from "vue-i18n";
import { NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import config from "@/config";

type INotificationsType = {
  [key: Path]: NotificationType[] | undefined;
};

export const notificationsTypes = computed<INotificationsType>(() => {
  return {
    all: undefined,
    subscriptions: [NotificationType.SUBSCRIPTION_PURCHASE_PROVIDER],
    purchases: [NotificationType.CONTENT_PURCHASE],
    followers: [NotificationType.PROFILE_FOLLOWING],
    likes: [NotificationType.LIKE],
    comments: [NotificationType.POST_REVIEW_CREATED, NotificationType.POST_REVIEW_MENTIONED],
    new_members: [NotificationType.MEMBER_APPROVED],
    ...(config.featureAppointments
      ? {
          appointments: [
            NotificationType.APPOINTMENT_REQUESTED,
            NotificationType.APPOINTMENT_CANCELLED_PROVIDER,
            NotificationType.APPOINTMENT_REMINDER_PROVIDER,
          ],
        }
      : {}),
  };
});

export type NotificationsKey = keyof typeof notificationsTypes.value;
